class ServiceStorage {
  constructor() {
    this.storage = {};
    this.get = this.get.bind(this);
    this.set = this.set.bind(this);
    this.clear = this.clear.bind(this);
    this.remove = this.remove.bind(this);
    this.setAll = this.setAll.bind(this);
  }

  get(key) {
    this._logger(`get`, key, this.storage[key]);
    return this.storage[key];
  }

  set(key, value) {
    this._logger(`set`, key, value);
    try {
      this.storage = { ...this.storage, [key]: value };
    } catch (e) {
      console.error(e);
    }
  }

  clear() {
    for (const key in this.storage) {
      delete this.storage[key];
    }
  }

  remove(key) {
    const updatedStorage = {};

    for (const id in this.storage) {
      if (id === key) continue;
      updatedStorage[id] = this.storage[id];
    }

    this.storage = updatedStorage;
  }

  setAll(obj) {
    for (const key in obj) this.set(key, obj[key]);
  }

  _logger() {
    // console.log(`ServiceStorage`, ...arguments);
  }
}

export const serviceStorage = new ServiceStorage();
